import React from 'react';

import css from './Animation.module.scss';

const LAST_ELEM = 2;
const DOWN = -1;
const UP = 1;

class Animation extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.palindrome = 'racecar';
    // todo: add emojis
    this.palindromes = [
      {
        'val': 'racecar',
        'emoji': '🏎️',
      },
      {
        'val': 'radar',
        'emoji': '📡',
      },
      {
        'val': 'kayak',
        'emoji': '🛶',
      },
      {
        'val': 'madam',
        'emoji': '💁',
      },
      {
        'val': 'reviver',
        'emoji': '🚑',
      },
      {
        'val': 'level',
        'emoji': '📏',
      },
      {
        'val': 'poop',
        'emoji': '💩',
      },
      {
        'val': 'xanax',
        'emoji': '💊',
      },
    ]
   
    this.state = {
      palindrome: 0,
      delta: DOWN,
      idx: this.palindromes[0].val.length + 2,
    };
  }

  onClick(idx) {
    if (this.state.delta < 0)
    {
      this.setState({
        ["animate"+this.state.idx]: this.state.delta < 0,
        idx: this.state.idx + this.state.delta + ((this.state.idx + this.state.delta) < LAST_ELEM ? UP : 0),
        delta: (this.state.idx + this.state.delta) < LAST_ELEM ? UP : DOWN,
      });
    }
    else {
      this.setState({
        ["animate"+this.state.idx]: this.state.delta < 0,
        idx: this.state.idx + this.state.delta + ((this.state.idx + this.state.delta) > this.palindromes[this.state.palindrome].val.length + 2 ? DOWN : 0),
        delta: (this.state.idx + this.state.delta) > this.palindromes[this.state.palindrome].val.length + 2 ? DOWN : UP,
      });
    }

    if ((this.state.idx + this.state.delta) > this.palindromes[this.state.palindrome].val.length + 2) {
      let next = Math.floor(Math.random() * this.palindromes.length);
      while (next === this.state.palindrome) {
        next = Math.floor(Math.random() * this.palindromes.length);
      }
      this.setState({
        palindrome: next,
        idx: this.palindromes[next].val.length + 2, // 9;
      });
    }
  }

  renderCards() {
    let cards = [];

    for (let i = 1 ; i <= this.palindromes[this.state.palindrome].val.length + 2; i ++) {
      cards.push(
        <div 
          className={[css.card, this.state["animate"+i]?css.animate:""].join(" ")} 
          onClick={() => this.onClick(i)}
          key={`card-${i}`}
        >
          <span className={css.centerText}>
            {i === 1 ? this.palindromes[this.state.palindrome].emoji : ""}
          </span>
          <span className={css.centerText}>
            {i === 1 ? this.palindromes[this.state.palindrome].val : this.palindromes[this.state.palindrome].val[i - LAST_ELEM]}
            {i === this.palindromes[this.state.palindrome].val.length + 2 ? "palindromes!" : ""}
          </span>
        </div>
      );
    }

    return cards
  }

  render() {
    return (
      <div className={css.container}>
        {this.renderCards()}
      </div>
    );
  }
}


export default Animation
